console.log('Slider script started');

function initializeSlider() {
    if (document.body.classList.contains('template-product')) {
        return;
    }

    const modal = document.getElementById('myModal');
    const allPhotosBtn = document.getElementById('allPhotosBtn');
    const closeBtn = modal ? modal.querySelector('.close') : null;
    const prevArrow = modal ? modal.querySelector('#prevArrow') : null;
    const nextArrow = modal ? modal.querySelector('#nextArrow') : null;
    const modalContent = modal ? modal.querySelector('.modal-content') : null;
    const images = modal ? modal.querySelectorAll('.es-character_dop') : [];
    const dots = modal ? modal.querySelectorAll('.dot') : [];
    let currentIndex = 0;

    // Check if we're on a product page and have the button
    if (!allPhotosBtn) {
        console.warn('Slider: allPhotosBtn not found');
        return;
    }

    // Show the button if we're on a product page, even if modal isn't ready yet
    if (allPhotosBtn) {
        allPhotosBtn.style.display = 'flex';
    }

    // If modal or other elements aren't ready, just show the button and return
    if (!modal || !closeBtn || !prevArrow || !nextArrow || images.length === 0) {
        console.warn('Slider: modal elements not ready, but showing button');
        return;
    }

    function showImage(index) {
        if (index >= images.length) index = 0;
        if (index < 0) index = images.length - 1;

        images.forEach((img, i) => {
            img.classList.toggle('active', i === index);
            if (dots[i]) dots[i].classList.toggle('active', i === index);
        });

        currentIndex = index;
    }

    const allPhotosBtnClone = allPhotosBtn.cloneNode(true);
    allPhotosBtn.parentNode.replaceChild(allPhotosBtnClone, allPhotosBtn);
    allPhotosBtnClone.addEventListener('click', () => {
        modal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        showImage(0);
    });

    const closeBtnClone = closeBtn.cloneNode(true);
    closeBtn.parentNode.replaceChild(closeBtnClone, closeBtn);
    closeBtnClone.addEventListener('click', () => {
        modal.style.display = 'none';
        document.body.style.overflow = '';
    });

    const prevArrowClone = prevArrow.cloneNode(true);
    prevArrow.parentNode.replaceChild(prevArrowClone, prevArrow);
    prevArrowClone.addEventListener('click', () => {
        showImage(currentIndex - 1);
    });

    const nextArrowClone = nextArrow.cloneNode(true);
    nextArrow.parentNode.replaceChild(nextArrowClone, nextArrow);
    nextArrowClone.addEventListener('click', () => {
        showImage(currentIndex + 1);
    });

    dots.forEach((dot, idx) => {
        const dotClone = dot.cloneNode(true);
        dot.parentNode.replaceChild(dotClone, dot);
        dotClone.addEventListener('click', () => {
            showImage(idx);
        });
    });

    window.removeEventListener('click', window.sliderCloseHandler);
    modalContent.removeEventListener('touchstart', window.sliderTouchStartHandler);
    modalContent.removeEventListener('touchend', window.sliderTouchEndHandler);

    window.sliderCloseHandler = (e) => {
        if (e.target === modal) {
            modal.style.display = 'none';
            document.body.style.overflow = '';
        }
    };
    window.addEventListener('click', window.sliderCloseHandler);

    let touchStartX = 0;
    let touchEndX = 0;

    window.sliderTouchStartHandler = (e) => {
        touchStartX = e.changedTouches[0].screenX;
    };
    window.sliderTouchEndHandler = (e) => {
        touchEndX = e.changedTouches[0].screenX;
        const diff = touchEndX - touchStartX;
        if (Math.abs(diff) > 50) {
            if (diff > 0) showImage(currentIndex - 1);
            else showImage(currentIndex + 1);
        }
    };

    modalContent.addEventListener('touchstart', window.sliderTouchStartHandler);
    modalContent.addEventListener('touchend', window.sliderTouchEndHandler);
}

// Initialize slider when DOM is ready
function initializeSliderWhenReady() {
    if (document.body.classList.contains('template-product')) {
        return;
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initializeSlider);
    } else {
        initializeSlider();
    }
}

// Also initialize when window is loaded
window.addEventListener('load', () => {
    if (document.body.classList.contains('template-product')) {
        return;
    }

    console.log('Window loaded, initializing slider');
    initializeSlider();
});

// Initialize immediately if possible
initializeSliderWhenReady();

if (window.Barba) {
    console.log('Attaching Barba handlers for slider');
    Barba.Dispatcher.on('newPageReady', () => {
        if (document.body.classList.contains('template-product')) {
            return;
        }

        console.log('Barba new page ready, reinitializing slider');
        
        // Delay initialization to ensure DOM is fully ready
        setTimeout(() => {
            initializeSlider();
            
            // Additional check for product page button
            const allPhotosBtn = document.getElementById('allPhotosBtn');
            if (allPhotosBtn && window.location.pathname.includes('/products/')) {
                allPhotosBtn.style.display = 'flex';
                console.log('Forced show allPhotosBtn on product page');
            }
        }, 100);
    });
    Barba.Dispatcher.on('initStateChange', () => {
        if (document.body.classList.contains('template-product')) {
            return;
        }

        console.log('Barba state change initiated for slider');
        window.removeEventListener('click', window.sliderCloseHandler);
        const modalContent = document.querySelector('.modal-content');
        if (modalContent) {
            modalContent.removeEventListener('touchstart', window.sliderTouchStartHandler);
            modalContent.removeEventListener('touchend', window.sliderTouchEndHandler);
        }
    });
} else {
    console.warn('Barba.js not found, skipping Barba handlers for slider');
}

console.log('Slider script loaded');
